import * as React from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/helpers/cn.helper";

import Typography from "../typography/typography";

const baseClasses = "inline-flex items-center justify-center px-3 py-1";

const badgeVariants = cva(baseClasses, {
  variants: {
    variant: {
      default: "border border-transparent bg-gray-50",
      primary: "bg-primary-active text-white",
      blue: "bg-badge-blue text-badge-blue-text",
      grey: "bg-badge-grey text-badge-grey-text",
      red: "bg-badge-red text-badge-red-text",
      yellow: "bg-badge-yellow text-badge-yellow-text",
      violet: "bg-badge-violet text-badge-violet-text",
      green: "bg-badge-green text-badge-green-text",
      "dark-red": "bg-badge-dark-red text-badge-dark-red-text",
      "pale-green": "bg-badge-pale-green text-badge-pale-green-text",
      magenta: "bg-badge-magenta text-badge-magenta-text",
      canceled: "",
      inactive: "",
    },
    typography: {
      bodyMMedium: [
        Typography.classes.Body.default,
        Typography.classes.Body.classnames.mMedium,
      ],
      bodyMRegular: [
        Typography.classes.Body.default,
        Typography.classes.Body.classnames.mRegular,
      ],
      indicator: "text-center text-xs font-medium",
    },
    edge: {
      roundedFull: "rounded-full",
      roundedMedium: "rounded-md",
    },
    size: {
      default: "h-7 max-h-7 min-h-7",
      small: "h-4 w-4 p-0",
      medium: "h-5 w-5 p-0",
      large: "h-6 w-6 p-0",
      indicator: "h-17 w-17 p-1",
    },
  },
  defaultVariants: {
    variant: "default",
    typography: "bodyMMedium",
    edge: "roundedFull",
    size: "default",
  },
});

interface IBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge: React.FC<IBadgeProps> = ({
  className,
  variant,
  typography,
  size,
  edge,
  ...props
}) => {
  return (
    <div
      className={cn(badgeVariants({ variant, typography, size, edge }), className)}
      {...props}
    />
  );
};
